import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';

function InputDropDown(
    {
        name,
        formik,
        staticList = null,
        optionValue = 'id',
        optionLabel = 'descricao',
        initialValue = [],
        callbackSetList = null,
        customFilter,
        valueIsCompleteObject = false,
        ...rest
    },
    ref
) {
    const [lista, setLista] = useState(staticList ?? initialValue);
    useEffect(() => {
        let isUnMounted = false;
        if (callbackSetList) {
            callbackSetList(customFilter).then((res) => {
                if (!isUnMounted) {
                    const finalData = Array.isArray(res) ? res : res?.data ?? res?.content;
                    setLista(finalData);
                }
            });
        }
        return () => {
            isUnMounted = true;
        };
    }, [customFilter]);

    useImperativeHandle(
        ref,
        () => {
            return { inputName: name, lista, setLista, restProps: rest };
        },
        [lista]
    );

    return (
        <Dropdown
            placeholder="Selecione"
            name={name}
            value={
                valueIsCompleteObject
                    ? formik?.values[name]?.[optionValue]
                    : formik?.values?.[name]?.id ?? formik.values?.[name]
            }
            options={staticList ?? lista}
            emptyMessage="Sem registro"
            optionLabel={optionLabel}
            showClear
            emptyFilterMessage="Sem registro"
            optionValue={optionValue}
            onChange={(ev) => {
                if (valueIsCompleteObject) {
                    formik.setFieldValue(
                        name,
                        lista.find((el) => el?.[optionValue] === ev.value)
                    );
                } else {
                    formik.handleChange(ev);
                }
            }}
            {...rest}
        />
    );
}

export default forwardRef(InputDropDown);
